/**
 * Article v2 — sommaire automatique.
 * Scanne les h2 du contenu, injecte des ids-ancres, remplit les listes
 * [data-article-toc-list] (sidebar desktop + accordéon mobile), gère le
 * scroll doux et le surlignage de la section active (calcul au scroll).
 * Sans h2 : retire tous les blocs [data-article-toc] du DOM.
 */
(function () {
  'use strict';

  function slugify(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function init() {
    var content = document.querySelector('[data-article-v2-content]');
    var tocBlocks = Array.prototype.slice.call(document.querySelectorAll('[data-article-toc]'));
    if (!content || tocBlocks.length === 0) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (headings.length === 0) {
      tocBlocks.forEach(function (block) { block.remove(); });
      return;
    }

    // Ids uniques sur chaque h2
    var seen = {};
    headings.forEach(function (h2) {
      if (h2.id) return;
      var base = slugify(h2.textContent.trim()) || 'section';
      var id = base;
      var i = 2;
      while (seen[id] || document.getElementById(id)) {
        id = base + '-' + i;
        i++;
      }
      seen[id] = true;
      h2.id = id;
    });

    // Remplit chaque liste (desktop + mobile) depuis la même source
    var allLinks = [];
    var lists = Array.prototype.slice.call(document.querySelectorAll('[data-article-toc-list]'));
    lists.forEach(function (list) {
      headings.forEach(function (h2) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h2.id;
        a.textContent = h2.textContent.trim();
        // Navigation d'ancre native : le navigateur re-cale la cible pendant les
        // décalages de layout (images lazy), là où scrollIntoView smooth est annulé.
        // Le défilement doux vient du CSS (scroll-behavior) + scroll-margin-top.
        a.addEventListener('click', function () {
          // Referme l'accordéon mobile après clic
          var details = a.closest('details');
          if (details) details.removeAttribute('open');
        });
        li.appendChild(a);
        list.appendChild(li);
        allLinks.push(a);
      });
    });

    // Surlignage de la section active : le dernier h2 passé au-dessus de la ligne de
    // lecture (30 % de l'écran, et au moins sous l'en-tête collant). Recalculé au scroll
    // (une fois par frame) : juste en descendant comme en remontant, et après un
    // rechargement en milieu de page — l'ancien IntersectionObserver ne voyait que les h2
    // traversant une bande de l'écran et restait en retard en remontant (MED-405).
    var sideList = document.querySelector('.article-v2__sidebar [data-article-toc-list]');
    var sideBox = sideList && sideList.closest('.article-v2__sidebar-inner');
    var current = -1;
    var ticking = false;
    var spy = function () {
      ticking = false;
      var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--f-header-height')) || 80;
      var line = Math.max(window.innerHeight * 0.3, headerHeight + 32);
      var index = 0;
      for (var i = 0; i < headings.length; i++) {
        if (headings[i].getBoundingClientRect().top <= line) index = i;
        else break;
      }
      if (index === current) return;
      current = index;
      var id = headings[index].id;
      allLinks.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
      // Sommaire plus haut que l'écran (pages piliers) : garde l'entrée active visible
      // en faisant défiler la boîte elle-même — jamais scrollIntoView, qui bougerait la page.
      if (sideBox && sideBox.scrollHeight > sideBox.clientHeight) {
        var li = sideList.children[index];
        if (li) sideBox.scrollTop = li.offsetTop - sideBox.clientHeight / 3;
      }
    };
    var requestSpy = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(spy);
    };
    window.addEventListener('scroll', requestSpy, { passive: true });
    window.addEventListener('resize', requestSpy);
    spy();

    // Deep-link : les ids étant posés en JS, le scroll natif vers le hash a déjà
    // échoué au chargement — on le rejoue (et une 2e fois après le load complet,
    // car les images lazy au-dessus décalent la cible).
    var scrollToHash = function () {
      if (!location.hash) return;
      var target;
      try {
        target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      } catch (e) {
        return;
      }
      if (target && headings.indexOf(target) !== -1) {
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
    };
    scrollToHash();
    if (document.readyState !== 'complete') {
      window.addEventListener('load', scrollToHash, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
